import React, { useContext as useContextCore } from 'react'
import type { ListFieldConfig, UseListResult, UseListWithSelection } from '@ztechapps/common.hook'
import { useListWithSelection } from '@ztechapps/common.hook'
import type { Product, RouteDef } from '@ztechapps/common.contract'
import { useProductList, useProductListFieldConfig } from '@ztechapps/product.common'
import { useInject, WebuiIocKey } from '@ztechapps/webui.contract'

export type LinkToAltPathFunction = ({ _id }: { _id: string }) => string

export type ProductListContextProps = {
  children: React.ReactNode
  filterCategory: string
}

export type ProductListContextType = {
  productList: UseListResult<Product>
  productListWithSelection: UseListWithSelection<Product>
  listFieldConfig: ListFieldConfig
  linkToAltPath?: LinkToAltPathFunction
} & Omit<ProductListContextProps, 'children'>

const context = React.createContext<ProductListContextType>({} as ProductListContextType)
const CoreProvider = context.Provider

export const ProductListProvider = ({ filterCategory, children, ...props }: ProductListContextProps) => {
  const listFieldConfig = useProductListFieldConfig()
  const productRouteDef = useInject<RouteDef>(WebuiIocKey.routes.productItem)
  const linkToAltPath = productRouteDef.altPath

  const productList = useProductList({
    listActionOptions: {
      storageKey: filterCategory,
    },
  })
  const productListWithSelection = useListWithSelection(productList?.list)

  return (
    <CoreProvider
      value={{ productList, productListWithSelection, filterCategory, listFieldConfig, linkToAltPath, ...props }}
    >
      {children}
    </CoreProvider>
  )
}

export const useProductListContext = () => useContextCore(context)
